var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758609152055,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8283,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M852.39808 341.80096q0-94.23872-45.01504-173.01504-45.0048-78.76608-123.07456-123.78112Q606.23872 0 512 0q-94.23872 0-172.30848 45.0048-78.06976 45.0048-123.07456 123.78112-45.01504 78.77632-45.01504 173.01504 0 87.21408 38.68672 161.76128 38.67648 74.5472 106.89536 121.67168 68.21888 47.11424 152.61696 56.96512V768H337.58208v84.39808h132.21888V1024h84.39808V852.39808h132.21888V768H554.19904v-85.80096q84.39808-9.85088 152.61696-56.96512 68.21888-47.12448 106.89536-120.96512 38.67648-73.84064 38.67648-162.4576zM512 597.80096q-71.7312 0-130.10944-34.4576-58.37824-34.4576-92.12928-93.53216Q256 410.73664 256 340.40832t33.76128-128.70656q33.75104-58.37824 92.12928-92.13952Q440.2688 85.80096 512 85.80096q71.7312 0 130.10944 33.76128 58.37824 33.76128 92.13952 92.13952Q768 270.06976 768 341.8112t-33.75104 130.10944q-33.76128 58.368-92.13952 92.12928-58.37824 33.75104-130.10944 33.75104z",
    fill: "#EC4899",
    "p-id": 8284
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman);
export default __webpack_public_path__ + "static/media/woman.6dc58478.svg";
export { ForwardRef as ReactComponent };